<life-di-nav></life-di-nav>

<div class="container-fulid text-center overflow-hidden" style="padding-top: 50px;">
  <div class="row justify-content-center">
    <div class="col-8">
      <h2 class="mb-5">
        เปลี่ยนรหัสผ่าน
      </h2>
      <form [formGroup]="changePasswordForm">
        <div class="form-group row justify-content-center">
          <label for="oldPassword" class="col-md-2 col-form-label text-left">รหัสผ่านเดิม</label>
          <div class="col-md-5">
            <input [type]="oldPasswordType ? 'text' : 'password'" class="form-control" id="oldPassword"
              formControlName="oldPassword">
            <span toggle="#oldPassword" class="toggle-password">
              <a>
                <img src="../../../../assets/dark-visibility.png" id="toggle-eye" alt="visibility"
                  (click)="oldPasswordToggle()">
              </a>
            </span>
          </div>
        </div>
        <div class="form-group row justify-content-center">
          <label for="newPasswordType" class="col-md-2 col-form-label text-left">รหัสผ่านใหม่</label>
          <div class="col-md-5">
            <input [type]="newPasswordType ? 'text' : 'password'" class="form-control" id="newPassword"
              formControlName="newPassword">
            <span toggle="#newPassword" class="toggle-password">
              <a>
                <img src="../../../../assets/dark-visibility.png" id="toggle-eye" alt="visibility"
                  (click)="newPasswordToggle()">
              </a>
            </span>
          </div>
        </div>
        <div class="form-group row justify-content-center">
          <label for="confirmNewPasswordType" class="col-md-2 col-form-label text-left">ยืนยันรหัสผ่านใหม่</label>
          <div class="col-md-5">
            <input [type]="confirmNewPasswordType ? 'text' : 'password'" class="form-control" id="confirmNewPassword" formControlName="confirmNewPassword">
            <span toggle="#confirmNewPassword" class="toggle-password">
              <a>
                <img src="../../../../assets/dark-visibility.png" id="toggle-eye" alt="visibility"
                  (click)="confirmNewPasswordToggle()">
              </a>
            </span>
          </div>
        </div>
        <div class="row justify-content-center mt-5">
          <div class="col-md-6">
            <div *ngIf="this.errorMsg !== null">
              <span class="text-danger">{{errorMsg}}</span>
            </div>
          </div>
          <div class="col-7">
            <lifedi-btn *ngIf="changePasswordForm.valid" lable="เปลี่ยนรหัสผ่าน"
              customStyle="color:white; background-color: #414A6B; width: 100%;"
              (click)="changePassword(changePasswordForm.value)">
            </lifedi-btn>
            <lifedi-btn *ngIf="!changePasswordForm.valid" lable="เปลี่ยนรหัสผ่าน" customStyle="width: 100%;"
              [disabled]="true">
            </lifedi-btn>
          </div>
        </div>
      </form>
    </div>
  </div>